"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonEntityDto = void 0;
const swagger_1 = require("@nestjs/swagger");
const class_transformer_1 = require("class-transformer");
let CommonEntityDto = class CommonEntityDto {
};
__decorate([
    swagger_1.ApiProperty({
        type: 'string',
        format: 'uuid',
        title: 'Id',
        description: 'The primary key of the resource.',
    }),
    class_transformer_1.Expose(),
    __metadata("design:type", String)
], CommonEntityDto.prototype, "id", void 0);
__decorate([
    swagger_1.ApiProperty({
        type: 'string',
        format: 'date-time',
        title: 'Created At',
        description: 'The date and time at which the resource was created.',
    }),
    class_transformer_1.Expose(),
    __metadata("design:type", Date)
], CommonEntityDto.prototype, "createdAt", void 0);
__decorate([
    swagger_1.ApiProperty({
        type: 'string',
        format: 'date-time',
        title: 'Updated At',
        description: 'The date and time at which the resource was last updated.',
    }),
    class_transformer_1.Expose(),
    __metadata("design:type", Date)
], CommonEntityDto.prototype, "updatedAt", void 0);
CommonEntityDto = __decorate([
    class_transformer_1.Exclude()
], CommonEntityDto);
exports.CommonEntityDto = CommonEntityDto;
//# sourceMappingURL=common-entity.dto.js.map